import React, { useEffect, useState } from 'react';
import { useRegistration } from '../../hooks/useRegistration';
import RegistrationStepper from './RegistrationStepper';
import { AUTHENTICATED } from '../../constants/user';
import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Box } from '@mui/material';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

const MainUserRegistration: React.FC = () => {
  const { theme } = useThemeContext();
  const {
    activeStep,
    error,
    userData,
    isSubmitting,
    handleSubmit,
    handleComplete,
    handleResendCode,
    fetchAppointmentDetails,
    fetchClientBookingDetails,
    fetchFormLinks,
    fetchInviteDetails,
    inviteDetails,
    inviteAcceptanceStatus,
    inviteAcceptanceError,
  } = useRegistration();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const [isAuthStatusReady, setIsAuthStatusReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (authStatus !== 'configuring') {
      setIsAuthStatusReady(true);
    }

    if (!isAuthStatusReady) {
      return;
    }

    if (authStatus === AUTHENTICATED && activeStep === 0) return navigate('/');
  }, [authStatus, isAuthStatusReady, navigate, activeStep]);

  return (
    <Box
      sx={{
        marginTop: '20px',
        padding: { xs: '8px', sm: '20px' },
        borderRadius: '16px',
        backgroundColor: theme.custom.components.mainUserRegistration.backgroundColor,
      }}
    >
      <RegistrationStepper
        isSubmitting={isSubmitting}
        activeStep={activeStep}
        email={userData.email}
        error={error}
        onSubmit={handleSubmit}
        onComplete={handleComplete}
        onResendCode={handleResendCode}
        fetchAppointmentDetails={fetchAppointmentDetails}
        fetchClientBookingDetails={fetchClientBookingDetails}
        fetchFormLinks={fetchFormLinks}
        fetchInviteDetails={fetchInviteDetails}
        inviteDetails={inviteDetails}
        inviteAcceptanceStatus={inviteAcceptanceStatus}
        inviteAcceptanceError={inviteAcceptanceError}
      />
    </Box>
  );
};

export default MainUserRegistration;
